import { App } from 'vue';
import {
  AuthenticationError,
  ConflictError,
  KeyError,
  NotImplementedError,
  ValidationError,
} from '@/exceptions';

const ExceptionPlugin = {
  install(app: App) {
    const exceptions = Object.freeze({
      AuthenticationError,
      ConflictError,
      KeyError,
      NotImplementedError,
      ValidationError,
    });

    app.provide('$exceptions', exceptions);
  },
};

export default ExceptionPlugin;
